module.exports = __webpack_public_path__ + "static/media/folderheart.fa1c0a52.svg";